<template>
  <div class="xuyue" v-loading="$store.getters.getLoading">
    <div class="top">
      <div class="in">
        <div class="nav" @click="showIframe(index)" :class="{ select: index == idx }" v-for="(item, index) in nav" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
    <!-- <div class="btn btn1" @click="showModel()"></div> -->
    <!-- <div class="btn btn2" @click="showIframe()"></div> -->
    <div class="grid-banner">
      <div class="inner">
        <img src="https://likeload.xlczg.com/marketing/images/xuyue/title.png" class="title">
        <div class="tips">快速学高情商说话，改善人际关系</div>
        <div class="btn btn1" @click="showIframe()">克服<span>说话紧张</span>秘诀<i>>></i> </div>
        <div class="btn btn2" @click="showIframe()">职场<span>高效沟通</span>大全<i>>></i></div>
        <div class="btn btn3" @click="showIframe()"><span>高情商</span>沟通话术<i>>></i></div>
        <div class="btn btn4" @click="showIframe()">与<span>家人沟通</span>方法<i>>></i></div>
        <div class="form">
          <input type="text" class="input1" v-model="input.name" placeholder="请输入您的姓名（必填）">
          <input type="text" class="input2" v-model.number="input.phone" placeholder="请输入手机号（必填）">
          <div class="form-btn" @click="submit(false)">立即领取</div>
        </div>
      </div>
    </div>

    <div class="grid-problem">
      <div class="inner">
        <div class="title">常见问题汇总</div>
        <div class="item item1">1、如何与人沟通和交流？<span @click="showIframe()">立即咨询</span></div>
        <div class="item item2">2、高情商回话技巧？<span @click="showIframe()">立即咨询</span></div>
        <div class="item item3">3、嘴笨的人怎么学会聊天？<span @click="showIframe()">立即咨询</span></div>
        <div class="item item4">4、怎么做到有效沟通？<span @click="showIframe()">立即咨询</span></div>
        <div class="item item5">5、如何改掉内向不爱说话？<span @click="showIframe()">立即咨询</span></div>
        <div class="item item6">6、沟通培训班多少钱？<span @click="showIframe()">立即咨询</span></div>
        <div class="item item7">7、沟通要学多久才有效果？<span @click="showIframe()">立即咨询</span></div>
        <div class="item item8">8、沟通课程都学些什么？<span @click="showIframe()">立即咨询</span></div>
      </div>
    </div>

    <div class="grid-low">
      <div class="inner">
        <div class="title"><span>情商低？</span>不会与人沟通？</div>
        <div class="item item1">
          <div class="i-title">当众讲话 不敢说</div>
          <div class="i-tips">在人多面前讲话紧张，<br />大脑空白、语无伦次</div>
          <div class="i-btn" @click="showIframe()">解决方案 >></div>
        </div>
        <div class="item item2">
          <div class="i-title">职场沟通 效果差</div>
          <div class="i-tips">客户沟通能力差，汇报<br />发言没逻辑、没重点</div>
          <div class="i-btn" @click="showIframe()">解决方案 >></div>
        </div>
        <div class="item item3">
          <div class="i-title">社交聚会 总尬聊</div>
          <div class="i-tips">情商低，一说话就冷场，<br />跟异性聊天没话题</div>
          <div class="i-btn" @click="showIframe()">解决方案 >></div>
        </div>
        <div class="item item4">
          <div class="i-title">家人沟通 常吵架</div>
          <div class="i-tips">不会与家人沟通，说几<br />句就吵架，吵完就冷战</div>
          <div class="i-btn" @click="showIframe()">解决方案 >></div>
        </div>
      </div>
    </div>

    <div class="grid-form">
      <div class="inner">
        <div class="title"><span>免费领取</span>沟通技巧提升方案</div>
        <div class="item">
          <div class="i-title">1、你目前的身份？</div>
          <div class="radio">
            <label> <input class="radio_type" name="radio_type" type="radio" checked="checked" /><span>职场新人</span></label>
            <label> <input class="radio_type" name="radio_type" type="radio" /><span>销售人员</span></label>
            <label> <input class="radio_type" name="radio_type" type="radio" /><span>新晋管理者</span></label>
            <label> <input class="radio_type" name="radio_type" type="radio" /><span>创业者</span></label>
            <label> <input class="radio_type" name="radio_type" type="radio" /><span>其它</span></label>
          </div>
        </div>
        <div class="item">
          <div class="i-title">2、在沟通上遇到的问题？</div>
          <div class="radio">
            <label> <input class="radio_type" name="radio_type1" type="radio" checked="checked" /><span>当众讲话</span></label>
            <label> <input class="radio_type" name="radio_type1" type="radio" /><span>职场沟通</span></label>
            <label> <input class="radio_type" name="radio_type1" type="radio" /><span>社交聊天</span></label>
            <label> <input class="radio_type" name="radio_type1" type="radio" /><span>家人沟通</span></label>
            <label> <input class="radio_type" name="radio_type1" type="radio" /><span>其它</span></label>
          </div>
        </div>
        <div class="form">
          <div class="f-title">填写资料马上领取</div>
          <input type="text" class="input1" v-model="input.name" placeholder="请输入您的姓名（必填）">
          <input type="text" class="input2" v-model.number="input.phone" placeholder="请输入手机号（必填）">
          <div class="form-btn" @click="submit(false)">立即领取</div>
        </div>
      </div>
    </div>

    <div class="grid-study">
      <div class="inner">
        <div class="title">4步带你<span>学习高情商沟通</span> 改善人际关系</div>
        <div class="item item1">
          <div class="i-title">01 <span>克服紧张</span></div>
          <div class="i-tips">自信勇敢表达<br />轻松当众讲话</div>
          <div class="i-btn" @click="showIframe()">了解更多 >></div>
        </div>
        <div class="item item2">
          <div class="i-title">02 <span>高情商聊天</span></div>
          <div class="i-tips">聊天有话题<br />高情商回话</div>
          <div class="i-btn" @click="showIframe()">了解更多 >></div>
        </div>
        <div class="item item3">
          <div class="i-title">03 <span>表达清晰</span></div>
          <div class="i-tips">学习汇报发言<br />掌握谈单秘诀</div>
          <div class="i-btn" @click="showIframe()">了解更多 >></div>
        </div>
        <div class="item item4">
          <div class="i-title">04 <span>化解矛盾</span></div>
          <div class="i-tips">学会理解包容<br />家人相处和睦</div>
          <div class="i-btn" @click="showIframe()">了解更多 >></div>
        </div>
        <div class="tab tab1">
          <div class="t-tips">职场</div>
          <div class="t-title">更多发展机会</div>
          <div class="t-btn" @click="showIframe()">了解更多 >></div>
        </div>
        <div class="tab tab2">
          <div class="t-tips">社交</div>
          <div class="t-title">人缘好，人脉广</div>
          <div class="t-btn" @click="showIframe()">了解更多 >></div>
        </div>
        <div class="tab tab3">
          <div class="t-tips">家庭</div>
          <div class="t-title">相处和睦幸福</div>
          <div class="t-btn" @click="showIframe()">了解更多 >></div>
        </div>
      </div>
    </div>

    <div class="grid-school">
      <div class="inner">
      </div>
    </div>

    <div class="mask" v-if="isModelShow" v-loading="$store.getters.getLoading">
      <div class="content">
        <div class="close" @click="closeMaskModel()"><i class="el-icon-delete"></i></div>
        <input type="text" class="name" v-model="input.name" placeholder="请输入您的姓名（必填）" />
        <input type="text" class="phone" v-model.number="input.phone" placeholder="请输入手机号（必填）" />
        <div class="btn" @click="submit(false)">立即领取</div>
      </div>
    </div>

    <div class="backTop" :style="{ display: scrollTop > 200 ? 'block' : 'none' }" @click="backTop"></div>
    <div class="fixed-content" :style="{ display: scrollTop > 200 ? 'block' : 'none' }">
      <div class="fixed-bg"></div>
      <div class="fixed">
        <input type="text" v-model.number="phone" placeholder="请输入您的手机号" v-model="phone" />
        <div class="btn" @click="submit(true)"></div>
      </div>
    </div>

    <div class="btn-content">
      <div class="btn b0" @click="showModel()">预约体验</div>
      <div class="btn b1" @click="showIframe()">在线客服</div>
    </div>
  </div>
</template>

<script>
import { addClue } from '@/api/modules/index/index'
import { callbackPunctate, callbackRegister } from '@/utils/common'
const regPhone = /^(1)\d{10}$/;
let _timer;
export default {
  data() {
    return {
      isIframeShow: false,
      isIframeAnimate: false,
      isSmallHeight: false,
      isModelShow: false,
      scrollTop: 0,
      phone: null,
      radio: "1",
      input: {
        name: null,
        phone: null,
        channel_id: '',
        site_url: '',
        note: ''
      },
      idx: 4,
      nav: [
        "线下教学",
        "学费价格",
        "口才培训",
        "高情商培训",
        "沟通培训",
      ],
    };
  },
  computed: {},
  mounted() {
    let height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.isSmallHeight = height < 860;

    setTimeout(() => {
      window.addEventListener("scroll", this.handleScrollBottom, true);
      this.handleScrollBottom();
    }, 300);

    this.init()

    var that = this;
    setTimeout(() => {
      that.showIframe();
    }, 3000);
  },
  methods: {
    backTop() {
      window.scrollTo(0, 0);
    },
    init(){
      this.input.channel_id = this.$route.query.channel_id;
      this.input.site_url = window.location.href;

    },
    handleScrollBottom() {
      this.scrollTop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
    },
    submit(flag) {
      let input = this.input;
      var orderId = new Date().getTime()
      var channelId = this.input.channel_id
      if (flag) {
        input.phone = this.phone;
      }
      if (!flag && !input.name) {
        this.$message({
          message: "请输入您的姓名",
          type: "warning",
        });
        return;
      }
      if (!regPhone.test(input.phone)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
        return;
      }
      addClue(input).then((result) => {
        if (result.code == 0) {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.isModelShow = false;
          window._agl && window._agl.push(['track', ['success', { t: 18 }]]);
          callbackPunctate(orderId, channelId);
          callbackRegister(channelId);
        } else {
          this.$message.error(result.message);
        }
        console.log(result);
      });
    },
    showModel() {
      this.input.name = null;
      this.input.phone = null;
      this.isModelShow = true;
    },
    closeMaskModel() {
      this.isModelShow = false;
    },
    showIframe(item) {
      if (item) {
        this.idx = item
      }
      mantis.requestChat();
    },
  },
};
</script>

<style lang="less" scoped>
.xuyue {
  font-family: 'Alibaba PuHuiTi 2.0';
  max-width: 1920px;
  margin: 0 auto;

  .grid-banner {
    width: 100%;
    height: 548px;
    max-width: 1920px;
    min-width: 1220px;
    background: url(https://likeload.xlczg.com/marketing/images/xuyue/bg_01.jpg)
      no-repeat center center;
    background-size: 1921px 548px;

    .inner {
      height: 548px;
      width: 1220px;
      margin: 0 auto;
      overflow: hidden;
      position: relative;

      .title {
        width: 645px;
        height: 122px;
        display: block;
        margin: 100px 0 0 0;
      }

      .tips {
        font-size: 44px;
        font-weight: 500;
        color: #ffffff;
      }

      .btn {
        width: 292px;
        height: 46px;
        position: absolute;
        font-size: 26px;
        font-weight: 500;
        color: #131313;
        line-height: 46px;
        text-indent: 20px;
        cursor: pointer;

        i,
        span {
          color: #a90302;
        }

        i {
          font-style: normal;
          line-height: 46px;
          position: absolute;
          right: 20px;
        }
      }

      .btn1 {
        top: 338px;
        left: 10px;
      }

      .btn2 {
        top: 338px;
        left: 318px;
      }

      .btn3 {
        top: 413px;
        left: 10px;
      }

      .btn4 {
        top: 413px;
        left: 318px;
      }

      .form {
        width: 330px;
        height: 395px;
        position: absolute;
        right: 8px;
        top: 95px;
        background: url(https://likeload.xlczg.com/marketing/images/xuyue/get.png)
          no-repeat center 20px;
        background-size: 309px 132px;

        input {
          width: 296px;
          height: 40px;
          border: 0;
          outline: none;
          border-radius: 8px;
          position: absolute;
          font-size: 17px;
          font-weight: 500;
          padding: 0 20px;
          box-sizing: border-box;
          background: transparent;
        }

        .input1 {
          top: 178px;
          left: 17px;
        }

        .input2 {
          top: 228px;
          left: 17px;
        }

        .form-btn {
          width: 296px;
          height: 50px;
          position: absolute;
          top: 295px;
          left: 17px;
          font-size: 32px;
          font-weight: 500;
          text-align: center;
          line-height: 56px;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }

  .grid-problem {
    width: 100%;
    height: 697px;
    max-width: 1920px;
    min-width: 1220px;
    background: url(https://likeload.xlczg.com/marketing/images/xuyue/problem.jpg)
      no-repeat center center;
    background-size: 1921px 697px;
    box-sizing: border-box;
    padding-top: 90px;

    .inner {
      height: 548px;
      width: 1220px;
      margin: 0 auto;
      overflow: hidden;
      position: relative;

      .title {
        font-size: 64px;
        font-weight: 900;
        color: #333333;
        text-align: center;
      }

      .item {
        height: 78px;
        line-height: 86px;
        width: 504px;
        position: absolute;
        font-size: 28px;
        font-weight: normal;
        color: #2e2e2e;

        span {
          float: right;
          width: 140px;
          text-align: center;
          font-size: 20px;
          font-weight: normal;
          color: #ffffff;
          cursor: pointer;
        }
      }

      .item1 {
        top: 166px;
        left: 50px;
      }

      .item2 {
        top: 243px;
        left: 50px;
      }

      .item3 {
        top: 321px;
        left: 50px;
      }

      .item4 {
        top: 398px;
        left: 50px;
      }

      .item5 {
        top: 166px;
        left: 675px;
      }

      .item6 {
        top: 243px;
        left: 675px;
      }

      .item7 {
        top: 321px;
        left: 675px;
      }

      .item8 {
        top: 398px;
        left: 675px;
      }
    }
  }

  .grid-low {
    width: 100%;
    height: 968px;
    max-width: 1920px;
    min-width: 1220px;
    background: url(https://likeload.xlczg.com/marketing/images/xuyue/low.jpg)
      no-repeat center center;
    background-size: 1921px 968px;
    box-sizing: border-box;
    padding-top: 115px;

    .inner {
      height: 968px;
      width: 1220px;
      margin: 0 auto;
      overflow: hidden;
      position: relative;

      .title {
        font-size: 64px;
        font-weight: 900;
        color: #333333;
        text-align: center;

        span {
          color: #d83724;
        }
      }

      .item {
        width: 285px;
        height: 500px;
        position: absolute;
        box-sizing: border-box;

        padding-top: 330px;

        .i-title {
          font-size: 32px;
          font-weight: 900;
          color: #622717;
          line-height: 36px;
          text-align: center;
        }

        .i-tips {
          font-size: 24px;
          font-weight: 500;
          color: #333333;
          line-height: 30px;
          margin-top: 15px;
          opacity: 0.8;
          padding-left: 25px;
          box-sizing: border-box;
          white-space: nowrap;
        }

        .i-btn {
          position: absolute;
          width: 100%;
          font-size: 20px;
          color: #ffffff;
          bottom: -10px;
          text-align: center;
          cursor: pointer;
          text-indent: 5px;
        }
      }

      .item1 {
        left: 10px;
        top: 174px;
      }

      .item2 {
        left: 313px;
        top: 174px;
      }

      .item3 {
        left: 618px;
        top: 174px;
      }

      .item4 {
        left: 925px;
        top: 174px;

        .i-btn {
          bottom: -13px;
        }
      }
    }
  }

  .grid-form {
    width: 100%;
    height: 607px;
    max-width: 1920px;
    min-width: 1220px;
    background: url(https://likeload.xlczg.com/marketing/images/xuyue/form.jpg)
      no-repeat center center;
    background-size: 1921px 607px;
    box-sizing: border-box;
    padding-top: 95px;

    .inner {
      height: 607px;
      width: 1220px;
      margin: 0 auto;
      overflow: hidden;
      position: relative;

      .title {
        font-size: 64px;
        font-weight: 900;
        color: #333333;
        text-align: center;
        margin-bottom: 60px;

        span {
          color: #d83724;
        }
      }

      .item {
        margin-bottom: 50px;

        .i-title {
          font-size: 28px;
          font-weight: 500;
          color: #0d0d0d;
          margin-bottom: 36px;
        }

        .radio {
          font-size: 24px;
          font-weight: normal;
          color: #0d0d0d;

          label {
            margin-right: 30px;
          }
        }
      }

      .form {
        width: 330px;
        height: 260px;

        border-radius: 20px;
        position: absolute;
        top: 145px;
        right: 12px;

        .f-title {
          font-size: 26px;
          font-weight: normal;
          font-style: italic;
          color: #333333;
          text-align: center;
          line-height: 60px;
        }

        input {
          width: 296px;
          height: 40px;
          border: 0;
          outline: none;
          border-radius: 8px;
          position: absolute;
          font-size: 17px;
          font-weight: 500;
          padding: 0 20px;
          box-sizing: border-box;
          background: transparent;
        }

        .input1 {
          top: 64px;
          left: 17px;
        }

        .input2 {
          top: 114px;
          left: 17px;
        }

        .form-btn {
          width: 296px;
          height: 50px;
          position: absolute;
          top: 173px;
          left: 17px;
          font-size: 32px;
          font-weight: 900;
          text-align: center;
          line-height: 56px;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }

  .grid-study {
    width: 100%;
    height: 1129px;
    max-width: 1920px;
    min-width: 1220px;
    background: url(https://likeload.xlczg.com/marketing/images/xuyue/study.jpg)
      no-repeat center center;
    background-size: 1921px 1129px;
    box-sizing: border-box;
    padding-top: 125px;

    .inner {
      height: 1129px;
      width: 1220px;
      margin: 0 auto;
      overflow: hidden;
      position: relative;

      .title {
        font-size: 64px;
        font-weight: 900;
        color: #333333;
        text-align: center;
        margin-bottom: 60px;

        span {
          color: #d83724;
        }
      }

      .item {
        width: 288px;
        box-sizing: border-box;
        border-radius: 5px;
        position: absolute;
        padding-top: 10px;

        .i-title {
          font-size: 38px;
          color: #202020;
          text-align: center;
          line-height: 60px;

          span {
            font-size: 38px;
            color: #622717;
            font-weight: 900;
          }
        }

        .i-tips {
          font-size: 28px;
          font-weight: normal;
          color: #333333;
          opacity: 0.8;
          text-align: center;
        }

        .i-btn {
          font-size: 20px;
          font-weight: normal;
          color: #ffffff;
          text-align: center;
          position: absolute;
          width: 100%;
          bottom: -12px;
        }
      }

      .item1 {
        left: 10px;
        top: 335px;
        height: 184px;
      }

      .item2 {
        left: 313px;
        top: 305px;
        height: 211px;
      }

      .item3 {
        left: 617px;
        top: 270px;
        height: 248px;
      }

      .item4 {
        left: 920px;
        top: 236px;
        height: 282px;
      }

      .tab {
        width: 375px;
        height: 238px;
        position: absolute;
        box-sizing: border-box;
        text-align: center;

        .t-tips {
          font-size: 32px;
          font-weight: 900;
          color: #ffffff;
          width: 90px;
          height: 50px;
          line-height: 50px;
        }

        .t-title {
          font-size: 24px;
          color: #ffffff;
          margin-top: 110px;
        }

        .t-btn {
          position: absolute;
          font-size: 20px;
          color: #ffffff;
          width: 100%;
          bottom: -13px;
        }
      }

      .tab1 {
        left: 11px;
        top: 583px;
      }

      .tab2 {
        left: 422px;
        top: 583px;
      }

      .tab3 {
        left: 830px;
        top: 583px;
      }
    }
  }

  .grid-school {
    width: 100%;
    height: 1217px;
    max-width: 1920px;
    min-width: 1220px;
    background: url(https://likeload.xlczg.com/marketing/images/xuyue/school.jpg)
      no-repeat center center;
    background-size: 1921px 1217px;
    box-sizing: border-box;
    padding-top: 125px;
  }
}

.fixed-content {
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  height: 100px;
  z-index: 991;
  min-width: 1220px;

  .fixed-bg {
    background: #3c3c3c;
    width: 100%;
    height: 100px;
    bottom: 0;
    left: 0;
    position: absolute;
  }

  .fixed {
    background: url(https://likeload.xlczg.com/marketing/images/xuyue/f.png)
      no-repeat center center;
    background-size: 1800px auto;
    width: 1220px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    height: 100px;

    .btn {
      width: 221px;
      height: 52px;
      border-radius: 36px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 52px;
      text-align: center;
      position: absolute;
      right: 30px;
      bottom: 20px;
      cursor: pointer;
    }

    input {
      background: #f8f8f8;
      width: 196px;
      height: 40px;
      position: absolute;
      right: 300px;
      bottom: 30px;
      border: 0;
      outline: none;
      font-size: 16px;
      font-weight: 400;
    }

    input::placeholder {
      color: #999999;
    }
  }
}

.backTop {
  width: 70px;
  height: 100px;
  background: url(data:image/png;base64,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)
    no-repeat 50%;
  background-size: cover;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 992;
  cursor: pointer;
}

.top {
  width: 100%;
  min-width: 1220px;
  line-height: 98px;
  position: fixed;
  top: 0;
  left: 0;
  height: 98px;
  box-sizing: border-box;
  z-index: 990;
  background: #fff;

  .in {
    background: url(https://likeload.xlczg.com/marketing/images/logo_b.png)
      no-repeat left center;
    background-size: auto 50px;
    flex-flow: row-reverse;
    display: flex;
    width: 1220px;
    min-width: 1220px;
    margin: 0 auto;

    .nav {
      font-size: 18px;
      font-weight: 400;
      margin: 0 18px;
      cursor: pointer;
      height: 98px;
      position: relative;
    }

    .nav:hover {
      color: #d83724;
      font-weight: 500;
    }

    .select,
    .select.nav:hover {
      color: #d83724;
      font-weight: 900;
    }
  }
}

.btn-content {
  width: 69px;
  height: 160px;
  background: #ffffff;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 7px;
  position: fixed;
  bottom: 300px;
  right: 0;
  z-index: 991;

  .btn {
    width: 100%;
    height: 60px;
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin-top: 13px;
    line-height: 100px;
    overflow: hidden;
    cursor: pointer;
  }

  .b0 {
    background: url(https://likeload.xlczg.com/marketing/images/f_0.png)
      no-repeat top center;
    background-size: 40px 40px;
  }

  .b1 {
    background: url(https://likeload.xlczg.com/marketing/images/f_1.png)
      no-repeat top center;
    background-size: 40px 40px;
  }
}

.xuyue {
  padding-bottom: 100px;
  padding-top: 98px;

  .mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;

    .content {
      width: 480px;
      height: 360px;
      background: #fff
        url(https://likeload.xlczg.com/marketing/images/xuyue/get.png) no-repeat
        center 20px;
      background-size: auto 132px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto auto;
      font-size: 18px;
      border-radius: 16px;
      overflow: hidden;

      .name {
        width: 360px;
        height: 36px;
        position: absolute;
        border: 2px solid #ccc;
        top: 170px;
        left: 60px;
        outline: none;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 0 10px;
      }

      .phone {
        width: 360px;
        height: 36px;
        position: absolute;
        border: 2px solid #ccc;
        top: 220px;
        left: 60px;
        outline: none;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 0 10px;
      }

      .btn {
        width: 260px;
        height: 52px;
        position: absolute;
        top: 280px;
        left: 110px;
        cursor: pointer;
        background: linear-gradient(0deg, #eb2122 0%, #ff5534 100%);
        border-radius: 23px;
        font-size: 32px;
        font-weight: 900;
        color: #ffffff;
        line-height: 52px;
        text-align: center;
      }

      .close {
        width: 50px;
        height: 50px;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        background: #fff
          url(https://likeload.xlczg.com/marketing/images/bidding/close.png)
          no-repeat center center;
        background-size: auto 16px;
      }
    }
  }
}
</style>
